module.exports = __webpack_public_path__ + "img/genswell_4_2.8bde0a4d.png";